import { FC } from 'react';
import { NavLink as MantineNavLink } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { cn } from '../utils/cn';

export interface NavItem {
  to?: string;
  label: string;
  icon: React.ComponentType<{ className?: string; stroke?: number }>;
}

export const NavLink: FC<{
  item: NavItem;
  onClick?: () => void;
  className?: string;
}> = ({ item, className, onClick }) => (
  <Link
    to={item.to}
    className="no-underline"
    key={item.label}
    onClick={onClick}
  >
    {({ isActive }) => (
      <MantineNavLink
        component="button"
        className={cn(className)}
        data-active={item.to && isActive ? true : undefined}
        leftSection={<item.icon stroke={1.5} />}
        label={item.label}
      />
    )}
  </Link>
);
